import { atom } from "jotai";
import { nanoid } from "nanoid";

export const canvasAtom = atom({ show: false, data: {} });

export const canvasAtom454kk = atom({
    show: true,
    data: {
        type: "image",
        data: {
            params: {
                id: "c3bf8bde-95b1-4c84-9092-936b99e85661",
            },
            value: "https://api.qureal.com/assets/c3bf8bde-95b1-4c84-9092-936b99e85661",
        },
    },
});

export const canvasAtom090 = atom({
    show: true,
    data: {
        type: "blog",
        data: {
            title: "Blog title",
            body: "hi, this is blog body",
        },
    },
});

export const canvasAtom7878 = atom({
    show: true,
    data: {
        type: "linkedin_post",
        data: {
            content: "hi, this is my linkedin post",
        },
    },
});

export const canvasAtom89 = atom({
    show: true,
    data: {
        type: "document",
        template_id: "0a6747c4-d90e-4b83-81f2-af6d194bca1d",
        data: [
            {
                title: "Introduction",
                section: {
                    type: "document_header",
                    content: "This is heading",
                },
            },
            {
                title: "First Section",
                section: {
                    type: "document_body",
                    content: "Hello <b>World</b>, what is going on buddy",
                },
            },
            {
                title: "Second Section",
                section: {
                    type: "document_body",
                    content: "Hello content, how are you <i>buddy</i>",
                },
            },
            {
                title: "Second Sectikkkon",
                section: {
                    type: "document_body",
                    content: "NICE, Hello content, how are you <i>buddy</i>",
                },
            },
        ],
        preset_id: "382b924a-3435-407a-9a13-6e9803d9b4ca",
    },
});

export const canvasAtom33 = atom({
    show: true,
    data: {
        type: "document",
        template_id: "0a6747c4-d90e-4b83-81f2-af6d194bca1d",
        prefill: {
            quote: {
                quote: '"Creativity is intelligence having fun."',
                author: "Albert Einstein",
            },
        },
        preset_id: "382b924a-3435-407a-9a13-6e9803d9b4ca",
    },
});

export const canvasAtom09090 = atom({
    show: true,
    data: {
        type: "design",
        data: {
            template_id: "0a6747c4-d90e-4b83-81f2-af6d194bca1d",
            prefill: {
                quote: {
                    quote: '"Creativity is intelligence having fun."',
                    author: "Albert Einstein",
                },
            },
            preset_id: "382b924a-3435-407a-9a13-6e9803d9b4ca",
        },
    },
});

export const canvasAtom11 = atom({
    show: true,
    data: {
        type: "design",
        data: {
            template_id: "0a6747c4-d90e-4b83-81f2-af6d194bca1d",
            primary_tag: "makar_sankranti",
            prefill: {
                festival_message: {
                    message: '"Creativity is intelligence having fun."',
                },
            },
            preset_id: "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98",
        },
    },
});

export const userInputsAtom = atom({
    enable: false,
    data: {},
});

export const suggestionsAtom = atom([
    {
        name: "New chat",
        action: { id: "new_chat" },
    },
]);

export const agentAtom = atom("master");

export const currentActionAtom = atom(null);

export const allSuggestionsAtom = atom((get) => {
    const canvas = get(canvasAtom);
    const suggestions = get(suggestionsAtom);

    let out = [];
    if (canvas.show) {
        switch (canvas?.data?.type) {
            case "design":
                out = [
                    { name: "Redesign", action: { id: "redesign" } },
                    { name: "Rewrite", action: { id: "rewrite" } },
                ];
                break;
            case "blog":
                out = [{ name: "Rewrite", action: { id: "rewrite" } }];
                break;
            case "linkedin_post":
                out = [{ name: "Rewrite", action: { id: "rewrite" } }];
                break;
        }

        out.push({
            name: "Hide canvas",
            action: { id: "hide_canvas" },
        });
    } else if (!canvas.show) {
        if (canvas?.data?.preset_id) {
            out = [{ name: "Show canvas", action: { id: "show_canvas" } }];
        }
    }
    return [...out, ...suggestions];
});

// export const canvasAtom = atom({
//     show: true,
//     data: {
//         "template_id": "b6b459cb-d226-4a8c-8633-5faca91bb8e3",
//         "prefill": {
//             "quote": {
//                 "quote": "The only way to do great work is to love what you do.",
//                 "author": "Steve Jobs"
//             }
//         }
//     }
// });

export const messageListAtom = atom([]);

export const draftMessageListAtom = atom([]);

export const isSocketConnectedAtom = atom(false);

export const socketStatusAtom = atom("disconnected");

export const threadIdAtom = atom(nanoid(7));

export const threadAtom = atom((get) => {
    return {
        id: get(threadIdAtom),
        messages: get(messageListAtom),
    };
});
